import { writable } from "svelte/store";
export const isProductDataLoading = writable(false);
export const categories = writable([]);
export const products = writable([]);
async function doFetch(callback) {
    isProductDataLoading.set(true);
    await callback();
    isProductDataLoading.set(false);
}
async function fetchCategories() {
    await doFetch(async () => {
        const res = await fetch("/wp-json/farmcomp-store/categories");
        if (res === null || res === void 0 ? void 0 : res.ok) {
            try {
                const json = await res.json();
                categories.set(json);
            }
            catch (e) {
                console.error(e, res);
            }
        }
    });
}
async function fetchProducts() {
    await doFetch(async () => {
        const res = await fetch("/wp-json/farmcomp-store/products");
        if (res === null || res === void 0 ? void 0 : res.ok) {
            try {
                const json = await res.json();
                products.set(json);
            }
            catch (e) {
                console.error(e, res);
            }
        }
    });
}
export async function fetchProductData() {
    await fetchCategories();
    await fetchProducts();
}
